import logger from "Libs/logger";

import { createAppAsyncThunk } from "Store/createAppAsyncThunk";
import { organizationByNameOrIdSelector } from "../organization.selectors";
import { isJson } from "Libs/utils";

export type DeleteOrganizationProps = {
  organizationDescriptionId: string;
};

export const deleteOrganization = createAppAsyncThunk(
  "app/organizations/delete_organization",
  async (
    { organizationDescriptionId }: DeleteOrganizationProps,
    { rejectWithValue, getState }
  ) => {
    try {
      const organization = organizationByNameOrIdSelector(getState(), {
        organizationNameOrId: organizationDescriptionId
      });
      if (!organization) {
        return rejectWithValue({
          error: `Organization ${organizationDescriptionId} not found`
        });
      }
      await organization.delete();
      return organization;
    } catch (err: unknown) {
      const error = isJson(err) ? JSON.parse(err) : err;

      logger(error, {
        action: "deleteOrganization",
        organizationDescriptionId
      });

      return rejectWithValue(error);
    }
  }
);
